import React from 'react';
import { Client, TripInfo, TravellerInfo } from '../../types/Quotation';
import { FaMapMarkerAlt, FaUsers, FaClock, FaBed } from 'react-icons/fa';
import '../../css/PreviewPDF.css';

interface SummaryBarProps {
  client: Client;
  tripInfo: TripInfo;
}

const SummaryBar: React.FC<SummaryBarProps> = ({ client, tripInfo }) => {
  const formatTravellers = (travellers: TravellerInfo) => {
    const { adults, children, infants } = travellers;
    const parts: string[] = [];
    if (adults) parts.push(`${adults} Adult${adults > 1 ? 's' : ''}`);
    if (children) parts.push(`${children} Child${children > 1 ? 'ren' : ''}`);
    if (infants) parts.push(`${infants} Infant${infants > 1 ? 's' : ''}`);
    return parts.join(', ') || 'N/A';
  };

  const totalNights = (tripInfo.places || []).reduce((sum, p) => sum + (p?.nights || 0), 0);

  return (
    <div className="trip-summary-bar">
      <div>
        {FaMapMarkerAlt({ size: 16 })}{' '}
        {tripInfo.places.map(p => {
          const cityName = p.label.includes(',') ? p.label.split(',')[0].trim() : p.label;
          return `${cityName} - ${p.nights} Nights`;
        }).join(' ✦ ')}
      </div>
      <div>{FaUsers({ size: 16 })} {formatTravellers(tripInfo.travellers)}</div>
      <div>{FaClock({ size: 16 })} {totalNights} Nights {totalNights + 1} Days</div>
      <div>{FaBed({ size: 16 })} Premium</div>
    </div>
  );
};

export default SummaryBar;
